import Tab from "../../plugins/tab.js";
const elements = document.querySelectorAll(".js-tab");
elements.forEach((element) => {
  new Tab(element, {
    defaultOpenPanel: 0, // 図録（1つ目のタブ）をデフォルトで開く
  });
});